import React from 'react';
import { Link } from 'react-router-dom';
import moment, { unix } from 'moment';
import { cloneDeep, sum, difference } from 'lodash';
import { getZoneOffsetByName, _toFixed } from '../../utils/utils';
import { parse, stringify } from 'query-string';

const excludedTabs = ['countries', 'landings', 'transits'];

const tabsWithFilteredParams = [
  'hourly',
  'devices',
  'browsers',
  'os',
];

const paramsNames = {
  times: ['dateFrom', 'dateTo'],
  hourly: ['hours'],
  offers: ['offers'],
  flows: ['flows'],
  devices: ['devices'],
  browsers: ['browsers'],
  os: ['os'],
  sources: ['sources'],
  pixels: ['offers'],
  subId1: ['subId1'],
  subId2: ['subId2'],
  subId3: ['subId3'],
  subId4: ['subId4'],
  subId5: ['subId5'],
};

export const getUtlParams = () => {
  const { search, pathname } = window.location;
  const parsedQuery = parse(search);
  return {search, pathname, parsedQuery};
};

const returnIfTabExcluded = tab => excludedTabs.find(key => key === tab);

export const filterParams = (tab, queryParams) => {
  if(tab === 'leads') {
    return queryParams;
  } else {
    const filteredParams = cloneDeep(queryParams);
    tabsWithFilteredParams.forEach(type => {
      const paramsToFilter = paramsNames[type];
      paramsToFilter.forEach(paramName => {
        delete filteredParams[paramName];
      });
    });
    return filteredParams;
  }
};

const LinkTo = ({ params, value, extraParams, className, memberId}) => {
  const { pathname, parsedQuery } = getUtlParams();
  parsedQuery.type = 'leads';
  if (params) {
    parsedQuery.statuses = params;
  } else {
    delete parsedQuery.statuses;
  }
  let extra = {};
  if(extraParams && extraParams.length) {
    extraParams.forEach(param => {
      extra = {...extra, ...param};
    });
  }

  const classes = className ? className : '';
  const fixedPathname = !memberId ? pathname : `${pathname}${memberId}`;
  return <Link
    to={{
      pathname: fixedPathname,
      search: `?${stringify({...parsedQuery, ...extra})}`,
      state: {withExtraParams: true}
    }}
  >
    <span className={classes}>{value}</span>
  </Link>;
};

const getExtraParams = ({ tab, config, stat, timeZones, currency }) => {
  if (tab.indexOf('subs') >= 0) {
    const subs = tab.replace('subs', '').split('');
    const subParams = [];
    if (subs.length) {
      subs.forEach(id => {
        subParams.push({[`subId${id}`]: -1});
        config.forEach(conf => {
          if (conf.title === `SubID${id}`) {
            const paramIndex = subParams.findIndex(param => Object.keys(param)[0] === `subId${id}`);
            if(stat[conf.id] && stat[conf.id][currency] && stat[conf.id][currency].label !== null) {
              subParams[paramIndex][`subId${id}`] = stat[conf.id][currency].value;
            }
          }
        });
      });
    } else {
      [1, 2, 3, 4, 5].forEach(id => {
        subParams.push({[`subId${id}`]: -1});
        config.forEach(conf => {
          if (conf.title === `SubID${id}`) {
            const paramIndex = subParams.findIndex(param => Object.keys(param)[0] === `subId${id}`);
            if(stat[conf.id] && stat[conf.id][currency] && stat[conf.id][currency].label !== null) {
              subParams[paramIndex][`subId${id}`] = stat[conf.id][currency].value;
            }
          }
        });
      });
    }
    return subParams;
  } else {
    const firstId = config[0].id;
    if(!stat[firstId]) {
      return [];
    }
    if(tab === 'times') {
      const {parsedQuery} = getUtlParams();
      const tz = parsedQuery.timeZone;
      let timeZone = '';
      if(tz) {
        timeZone = getZoneOffsetByName(timeZones, tz);
      }
      return paramsNames[tab].map(par =>({
        [par]: unix(stat[firstId][0]).utcOffset(timeZone).format("DD.MM.YYYY")
      }));
    }
    return paramsNames[tab].map(par => ({[par]: stat[firstId][0]}));
  }
};

export const getLinkToConversationTable = ({
  value,
  statId,
  tab,
  stat,
  config,
  timeZones,
  isTotal,
  isSubData,
  currency,
  isMembers,
}) => {
  if (+value === 0 || isSubData || returnIfTabExcluded(tab)) {
    return value;
    // return statId === 30 ? <span className='gray'>{value}</span> : value;
  }
  let extraParams = [];
  if(!isTotal) {
    extraParams = getExtraParams({ tab, config, stat, timeZones, currency });
  }
  let memberId = '';
  if(isMembers) {
    const webmasterField = config.find(field => field.type === 'webmaster_id');
    const webmasterFieldId = webmasterField ? webmasterField.id : 1;
    const slaveId = stat[webmasterFieldId][0];
    memberId = `/${slaveId}`;
  }
  switch (statId) {
    case 127:
      return <LinkTo
        value={value}
        extraParams={extraParams}
        memberId={memberId}
      />;
    case 27:
      return <LinkTo
        value={value}
        params="1,3"
        extraParams={extraParams}
        memberId={memberId}
      />;
    case 28:
      return <LinkTo
        value={value}
        params="0"
        extraParams={extraParams}
        memberId={memberId}
      />;
    case 29:
      return <LinkTo
        value={value}
        params="2"
        extraParams={extraParams}
        memberId={memberId}
      />;
    case 30:
      return <LinkTo
        value={value}
        params="66"
        extraParams={extraParams}
        memberId={memberId}
        className='gray'
      />;
    default:
      break;
  }
};

export const removeEmptyStats = ({stats, currency, tab, config}) => {
  if(!stats) {
    return [];
  }
  if(!stats.length || tab === 'leads' || tab === 'times' || tab === 'timesSp' || tab === 'hourly' || tab === 'flows' || tab === 'webmasters' || tab.search(/subs/gi) !== -1) {
    return stats;
  }
  const keysToFilter = config.filter(({ group }) => group !== '__EMPTY__').map(({ id }) => id);
  const filteredStats = stats.filter(stat => {
    const valuesToCount = keysToFilter.map(key => stat[key] ? stat[key][currency] : null)
        .map(function (val) {
          if (typeof val === 'string') {
            val = parseInt(val.replace(/[^0-9]+/g, ''));
          }
          return val ? val : 0;
        });
    if (sum(valuesToCount) > 0) {
      return stat;
    }
  });
  return filteredStats;
};

export const correctFiltersIfInvalid = filters => {
  const correctedFilters = { 
    ...filters, 
    template: '7' 
  };
  Object.keys(correctedFilters).forEach(key => {
    if(key === 'dateFrom' || key === 'dateTo') {
      const currentFormattedDate = moment().format('DD.MM.YYYY');
      const prevFormattedDate = moment().subtract(6, 'd').format('DD.MM.YYYY');
      if(correctedFilters[key] === 'Invalid date' || !moment(correctedFilters[key], 'DD.MM.YYYY').isValid()) {
        if(key === 'dateFrom') {
          correctedFilters[key] = prevFormattedDate;
        } else {
          correctedFilters[key] = currentFormattedDate;
        }
      }
      const currentDate = moment(currentFormattedDate, 'DD.MM.YYYY').format('X');
      const dateToCheck = moment(correctedFilters[key], 'DD.MM.YYYY').format('X');
      if(dateToCheck - currentDate > 0) {
        if(key === 'dateFrom') {
          correctedFilters[key] = prevFormattedDate;
        } else {
          correctedFilters[key] = currentFormattedDate;
        }
      }
    }
    if(key === 'currency') {
      if(correctedFilters[key] > 2 || correctedFilters[key] < 0) correctedFilters[key] = 0;
    }
    if(key === 'type') {
      // пришлось захардкодить, из стейта не достать вовремя
      const validTypes = [
        'times',
        'countries',
        'offers',
        'flows',
        'devices',
        'subs',
        'leads',
        'pixels',
        'landings',
        'sources',
      ];
      if(!validTypes.includes(correctedFilters[key])){
        correctedFilters[key] = validTypes[0];
      }
    }
  });
  if (correctedFilters.dateFrom && correctedFilters.dateTo) {
    const { dateFrom, dateTo } = correctedFilters;
    if (
      Number(moment(dateFrom, 'DD.MM.YYYY').format('X')) >
      Number(moment(dateTo, 'DD.MM.YYYY').format('X'))
    ) {
      correctedFilters.dateFrom = dateTo;
      correctedFilters.dateTo = dateFrom;
    }
  }
  return correctedFilters;
};

export const getSlaveId = () => window.location.pathname.replace('/tools/master/', '');

export const isMaster = () => window.location.pathname.includes('tools/master');
export const isMembersPage = () => window.location.pathname === '/tools/master';
